import { createSelector } from 'reselect';
import { uiSelector } from '../common/state/selectors/issue-selector';

export const isInvestigateIncidentModalOpenedSelector = createSelector(
	uiSelector,
	(uiState) => uiState.investigateIncident.showInvestigateIncidentModal,
);
